export class RegExConstants {
  public static readonly QUERY_COLUMN: RegExp = /(?<=select)(.*)(?=from)/gis;
}
